import React, { useState } from 'react';
import { Collapse, Button } from 'react-bootstrap';

/**
 * @param {{ extractedData: Object, editedSnapshot?: Object }} props
 */
const ExtractionDebugPanel = ({ extractedData, editedSnapshot }) => {
  const [open, setOpen] = useState(false);
  const meta = extractedData?.meta || {};

  return (
    <div className="mt-3 border-top pt-2">
      <Button
        variant="link"
        size="sm"
        className="p-0 text-muted"
        onClick={() => setOpen(!open)}
        type="button"
      >
        {open ? 'Hide' : 'Show'} debug extraction
      </Button>
      <Collapse in={open}>
        <div className="mt-2 small">
          {meta.parserVersion && (
            <div>
              <strong>Parser:</strong> {meta.parserVersion}
            </div>
          )}
          {meta.pageCount != null && (
            <div>
              <strong>Pages:</strong> {meta.pageCount}
            </div>
          )}
          {(meta.supplierFormat || meta.parserFormat) && (
            <div>
              <strong>Format:</strong> {meta.supplierFormat || meta.parserFormat}
            </div>
          )}
          {meta.rawText && (
            <pre
              className="bg-light p-2 mt-2 english-value"
              style={{ maxHeight: 200, overflow: 'auto', fontSize: '0.75rem' }}
            >
              {meta.rawText}
            </pre>
          )}
          <details className="mt-2">
            <summary className="text-muted">Full edited JSON</summary>
            <pre
              className="bg-light p-2 english-value"
              style={{ maxHeight: 240, overflow: 'auto', fontSize: '0.7rem' }}
            >
              {JSON.stringify(editedSnapshot || extractedData, null, 2)}
            </pre>
          </details>
        </div>
      </Collapse>
    </div>
  );
};

export default ExtractionDebugPanel;
